import React, { useState, useEffect } from "react";
import { Button, Typography, Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useParams } from "react-router-dom";
import { SERVER_BASE_ADDRESS } from "../../globals/const";
import { useTranslation } from "react-i18next";
export default function FPODocuments() {
  const { fpoId } = useParams();
  const { t } = useTranslation();

  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    // Fetch existing documents
    api
      .get("/fpo/list-documents-for-fpo?fpoId=" + fpoId)
      .then((response) => setDocuments(response.data))
      .catch((error) => console.error("Error fetching documents:", error));
  }, []);

  const downloadDocument = (documentId) => {
    window.open(`${SERVER_BASE_ADDRESS}/fpo/documents/download/${documentId}`, "_blank");
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <Grid
          container
          // spacing={1}
          justify="center"
          direction="column"
          style={{ marginTop: "10px" }}>
          <Typography variant="h5">{t("FPO Documents")}</Typography>

          <Grid item xs={12}>
            {documents.map((doc) => (
              <div key={doc.id}>
                <Typography>{doc.name}</Typography>
                <Button onClick={() => downloadDocument(doc.id)}>{t("Download")}</Button>
              </div>
            ))}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
